import { render, staticRenderFns } from "./OrgHomeRetainedCasesCharts.vue?vue&type=template&id=5a80edcc&scoped=true&"
import script from "./OrgHomeRetainedCasesCharts.vue?vue&type=script&lang=js&"
export * from "./OrgHomeRetainedCasesCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80edcc",
  null
  
)

export default component.exports